import { useCallback } from 'react';
import { useFireEvent } from 'hooks/useFireEvent';
import { StepViewerEvents } from 'constants/app/eventbus-events';

type UseStepViewerNavigationProps = {
  eventId?: string;
};

export const useStepViewerNavigation = ({
  eventId
}: UseStepViewerNavigationProps) => {
  const { fireEvent } = useFireEvent();
  const next = useCallback(() => {
    fireEvent({
      key: StepViewerEvents.NextAction,
      id: eventId
    });
  }, [eventId]);
  const previous = useCallback(() => {
    fireEvent({
      key: StepViewerEvents.PreviousAction,
      id: eventId
    });
  }, [eventId]);

  return {
    next,
    previous
  };
};
